import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY } from '@constant/colors';

const Twitter = ({ width }) => (
  <svg width={width} height={width} viewBox="262 24 17 14">
    <path
      d="M277.972039,24.25 C277.309208,24.625002 276.592932,24.885416 275.823191,25.03125 C275.160359,24.343746 274.337176,24 273.353618,24 C272.434206,24 271.643095,24.322914 270.980263,24.96875 C270.317431,25.614586 269.98602,26.385412 269.98602,27.28125 C269.98602,27.531252 270.018092,27.781248 270.082237,28.03125 C268.713809,27.96875 267.425581,27.63542 266.217515,27.03125 C265.009451,26.42708 263.988491,25.614588 263.154605,24.59375 C262.83388,25.093752 262.67352,25.64583 262.67352,26.25 C262.67352,27.416672 263.175982,28.322914 264.180921,28.96875 C263.646379,28.96875 263.143917,28.833334 262.67352,28.5625 L262.67352,28.625 C262.67352,29.395838 262.924751,30.08333 263.42722,30.6875 C263.92969,31.29167 264.576475,31.677082 265.367599,31.84375 C265.068255,31.90625 264.768916,31.9375 264.469572,31.9375 C264.255756,31.9375 264.041941,31.916666 263.828125,31.875 C264.063324,32.54167 264.464223,33.08854 265.03084,33.515624 C265.597454,33.94271 266.244241,34.15625 266.971217,34.15625 C265.752461,35.0937546 264.362671,35.5625 262.801809,35.5625 C262.545229,35.5625 262.277962,35.5520834 262,35.53125 C263.582245,36.5104216 265.303444,37 267.163651,37 C268.660369,37 270.028776,36.7187528 271.268914,36.15625 C272.509053,35.5937472 273.519321,34.85938 274.299752,33.953124 C275.080185,33.04687 275.684209,32.04688 276.111842,30.953124 C276.539475,29.85937 276.753289,28.760422 276.753289,27.65625 L276.753289,27.25 C277.416121,26.77083 277.972037,26.19792 278.421053,25.53125 C277.800983,25.802084 277.159542,25.979166 276.496711,26.0625 C277.223687,25.624998 277.715458,25.020838 277.972039,24.25 L277.972039,24.25 Z"
      stroke="none"
      fill={OSLO_GRAY}
      fillRule="evenodd"
    />
  </svg>
);

Twitter.propTypes = {
  width: PropTypes.number,
};

Twitter.defaultProps = {
  width: 20,
};

export default Twitter;
